import css from 'styled-jsx/css';
import { MQ_MEDIUM, MQ_LARGE } from 'constants/mq';
import { sharedPalette } from 'styles/colors/constants';
import { sansSerif } from 'styles/css-constants';

export default css`
  .RecipeBoxTagForm__addTagForm {
    padding: 1rem 0;
    font-size: initial;
    background: #ebe8e8;
    margin-left: -0.8rem;
    margin-right: -0.8rem;
    width: 99%;
  }

  .RecipeBoxTagForm__addTagForm a {
    color: #666;
  }

  .RecipeBoxTagForm__addTagInput {
    padding: 0 1rem;
    display: flex;
    margin-bottom: 0.5rem;
  }

  .RecipeBoxTagForm__addTagInput .button,
  .RecipeBoxTagForm__addTagInput input {
    padding: 0.5rem;
  }

  .RecipeBoxTagForm__addTagInput .button {
    background: ${sharedPalette.watermelon};
    font-family: ${sansSerif};
    color: white;
    font-weight: 300;
    border: none;
    font-size: 0.7rem;
  }
  .RecipeBoxTagForm__addTagInput .button:disabled {
    background: #c9c9c9;
  }

  .RecipeBoxTagForm__addTagInput input {
    font-size: initial;
    border: none;
    color: black;
    width: 100%;
  }

  .RecipeBoxTagForm__addTagInput input::placeholder {
    font-style: italic;
    color: #b5b5b5;
  }

  .RecipeBoxTagForm__myTags {
    margin-top: 1rem;
    padding: 0rem 0.8rem 0;
  }

  .RecipeBoxTagForm .RecipeBoxTagForm__myTags strong {
    padding-left: 0;
  }

  .RecipeBoxTagForm strong {
    color: #666;
    display: block;
    font-size: 0.8rem;
    padding: 1rem 1rem 0;
    margin-bottom: 0.5rem;
  }

  .RecipeBoxTagForm p {
    color: #666;
    font-size: 0.8rem;
    padding: 0 1rem 0;
  }

  .RecipeBoxTagForm__usedTagForm {
    margin-top: 0.5rem;
    max-height: 220px;
    overflow-x: hidden;
    overflow-y: auto;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
  }

  .RecipeBoxTagForm__usedTagForm button {
    min-width: 50px;
    font-size: var(--fontScaleNeg2);
    margin: 0.5rem 0.5rem 0 0;
    border-radius: 25px;
    font-family: ${sansSerif};
    font-weight: bold;
    text-transform: uppercase;
    padding: 0.35rem 1rem;
    cursor: pointer;
    color: #705e5d;
  }

  .RecipeBoxTagForm__usedTagForm .button--hasBeenAdded {
    color: #fff;
    background: #321917;
  }

  @media ${MQ_MEDIUM} {
    .RecipeBoxTagForm__usedTagForm.expanded {
      max-height: none;
    }
  }

  @media ${MQ_LARGE} {
    .RecipeBoxTagForm__usedTagForm {
      max-height: 120px;
    }
  }
`;
